function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsxs as t, jsx as a } from "react/jsx-runtime";
import { useIsInverseVariant as n } from "../../theme-variant-context.js";
import { vars as e } from "../../skins/skin-contract.css-mistica.js";
const i = (_param)=>{
    var { color: c , size: r = 24  } = _param, l = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const s = n(), o = c !== null && c !== void 0 ? c : s ? e.colors.inverse : e.colors.neutralHigh;
    return /* @__PURE__ */ t("svg", _object_spread_props(_object_spread({
        width: r,
        height: r,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, l), {
        children: [
            /* @__PURE__ */ a("path", {
                fill: o,
                d: "M9.797 13.88c0 .208.168.379.378.379a.38.38 0 00.381-.379v-.547c.558-.07 1.026-.26 1.367-.556.44-.381.672-.919.672-1.552 0-.778-.356-1.748-2.039-1.993V7.214c.276.054.548.155.83.308l.008.003c.095.05.198.081.305.084.283 0 .512-.23.512-.513 0-.112-.039-.322-.302-.484a3.31 3.31 0 00-1.353-.445v-.275a.38.38 0 00-.381-.381.38.38 0 00-.378.38v.263c-1.228.109-2.006.9-2.006 2.074 0 .764.351 1.721 2.006 1.965v2.13c-.43-.056-.862-.228-1.291-.513a.641.641 0 00-.342-.109.526.526 0 00-.532.521c0 .19.084.348.252.465a3.833 3.833 0 001.913.669v.524zm.759-1.578v-1.997c.86.186.989.568.989.956 0 .546-.37.922-.989 1.041zm-.76-3.185c-.83-.187-.951-.573-.951-.934 0-.555.35-.914.952-.996v1.93z"
            }),
            /* @__PURE__ */ a("path", {
                fill: o,
                d: "M2.175 9.984a7.846 7.846 0 007.846 7.846 7.792 7.792 0 005.138-1.918l5.697 5.697a.55.55 0 00.395.165.561.561 0 00.398-.958l-5.704-5.704A7.848 7.848 0 004.472 4.435a7.854 7.854 0 00-2.297 5.55zm1.12 0a6.726 6.726 0 016.726-6.725 6.672 6.672 0 014.756 1.972 6.724 6.724 0 010 9.473 6.728 6.728 0 01-9.512.036 6.732 6.732 0 01-1.97-4.756z"
            })
        ]
    }));
}, f = i;
export { f as default };
